import { onUseQueries } from './onUseQueries'

interface IQueries {
    sortindFiled?: string | null
    filters?: IFilterCondition[]
    limit?: number
    offset?: number
    count?: boolean
}

export const onUseOdataQueries2 = (queries: IQueries) => {
    const { filters = null, limit = null, offset = null, count = false, sortindFiled = null } = queries

    const onHandleFilterResult = (filterString: string | null) => {
        if (filterString) {
            const separated = filterString.split(' ').filter((item) => item !== '')
            const tail = separated[separated.length - 1]
            if (tail === 'and' || tail === 'or') {
                return separated.slice(0, -1).join(' ')
            }
            return filterString
        }
        return null
    }

    const filter = filters
        ? filters.reduce((acc, item) => {
              if (item.isExist) {
                  acc += `${item.filterString}`
                  if (item.conditionParam) {
                      acc += ` ${item.conditionParam} `
                  }
              }
              return acc
          }, '')
        : null

    const resopnse: Record<string, string | number | boolean | null> = {
        $filter: onHandleFilterResult(filter),
        $top: limit,
        $skip: offset && limit ? offset * limit : null,
        $count: count,
        $orderby: sortindFiled ? `${sortindFiled}` : null
    }
    return onUseQueries(resopnse)
}

export interface IFilterCondition {
    filterString: string
    conditionParam?: 'and' | 'or' | null
    isExist: boolean
}
